import { render, staticRenderFns } from "./FarmTools.vue?vue&type=template&id=4077bdbf&scoped=true&"
import script from "./FarmTools.vue?vue&type=script&lang=ts&"
export * from "./FarmTools.vue?vue&type=script&lang=ts&"
import style0 from "./FarmTools.vue?vue&type=style&index=0&id=4077bdbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4077bdbf",
  null
  
)

export default component.exports